export const uniqueNumber = () => {
  const date = new Date();
  const timestamp = date.getTime(); // Get the current timestamp in milliseconds
  const uniqueNumber = timestamp % 100000000; // Use modulo operator to limit the number within 8 digits

  return uniqueNumber;
};
